








































































import BaseFormEdit from '../../models/base.form.edit';
import { Component } from 'vue-property-decorator';
import Vue from 'vue';

import { VueEditor } from "vue2-editor";

Vue.component('VueEditor', VueEditor);

@Component({ })
export default class Edit extends BaseFormEdit {
  form = { subject: '', message: '' } as any;
customToolbar = [
  
  [{ font: [] }],
  ["bold", "italic", "underline", "strike"], // toggled buttons
  [
    { align: "" },
    { align: "center" },
    { align: "right" },
    { align: "justify" }
  ],
  ["blockquote", "code-block"],
  [{ list: "ordered" }, { list: "bullet" }, { list: "check" }],
  [{ indent: "-1" }, { indent: "+1" }], 
  [{ color: [] }, { background: [] }], 
  ["link", "image"],
  ["clean"] 
]
}
